/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  TEAM_FETCH_REQUEST,
  TEAM_FETCH_REQUEST_SUCCESS,
  TEAM_FETCH_REQUEST_FAILURE,
  TEAM_UPSERT_REQUEST,
  TEAM_UPSERT_REQUEST_SUCCESS,
  TEAM_UPSERT_REQUEST_FAILURE,
  TEAM_CLEAN_REQUEST,
  TEAM_ERROR_CLEAN_REQUEST,
  SINGLE_TEAM_FETCH_REQUEST,
  SINGLE_TEAM_FETCH_REQUEST_SUCCESS,
  SINGLE_TEAM_FETCH_REQUEST_FAILURE,
  SINGLE_TEAM_CLEAN_REQUEST,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  singleTeamPayload: [],
  singleTeamLoading: false,
  singleTeamError: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const teamReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TEAM_UPSERT_REQUEST:
    case TEAM_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TEAM_UPSERT_REQUEST_SUCCESS:
    case TEAM_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data?.currentPage,
          pageSize: action.data?.limit,
          total: action.data?.totalRecords,
          totalPage: action.data?.totalRecords
            ? Math.round(action.data.totalRecords / action.data.limit) +
              (Math.abs(action.data.totalRecords / action.data.limit) >
              Math.round(action.data.totalRecords / action.data.limit)
                ? 1
                : 0)
            : 0,
          showSizeChanger: true,
        },
      });

    case TEAM_UPSERT_REQUEST_FAILURE:
    case TEAM_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SINGLE_TEAM_FETCH_REQUEST:
      return Object.assign({}, state, {
        singleTeamLoading: true,
      });

    case SINGLE_TEAM_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singleTeamPayload: action.data,
        singleTeamLoading: false,
        singleTeamError: {},
      });

    case SINGLE_TEAM_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleTeamLoading: false,
        singleTeamError: action.error,
      });

    case TEAM_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    case TEAM_ERROR_CLEAN_REQUEST:
      return Object.assign({}, state, {
        errors: {},
      });

    case SINGLE_TEAM_CLEAN_REQUEST:
      return Object.assign({}, state, {
        singleTeamPayload: [],
        singleTeamLoading: false,
        singleTeamError: {},
      });

    default:
      return state;
  }
};

export default teamReducer;
